import * as React from "react";
import { Dropzone as MantineDropzone } from "@mantine/dropzone";
const Dropzone = ({ children, ...props }) => /* @__PURE__ */ React.createElement(MantineDropzone, { ...props }, children);
Dropzone.Accept = MantineDropzone.Accept;
Dropzone.Reject = MantineDropzone.Reject;
Dropzone.Reject = MantineDropzone.Reject;
Dropzone.Idle = MantineDropzone.Idle;
export default Dropzone;
